export const CATEGORIES = [
  { label: 'LARGE APPLIANCE', value: 'LA' },
  { label: 'SMALL APPLIANCE', value: 'SA' },
  { label: 'MOBILES', value: 'MO' },
  { label: 'COMP', value: 'CO' },
];

export const ifscRegex = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;

export const phoneRegex = /^[0-9]{10}$/;

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const pincodeRegex = /^[0-9]{6}$/;

export const panRegex = /([A-Z]{5}[0-9]{4}[A-Z]{1})/;

export const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const accountRegex = /^[0-9]+$/;

export const alphaNumericRegex = /^[0-9a-zA-Z]+$/;

export const vendorInputData = [
  {
    title: 'Vendor Name',
    type: 'text',
    placeholder: 'Vendor Name',
    name: 'firmName',
  },
  {
    title: 'Phone Number',
    type: 'number',
    placeholder: 'Phone Number',
    name: 'mobileNumber',
  },
  {
    title: 'Official Email Id',
    type: 'email',
    placeholder: 'Official Email Id',
    name: 'emailId',
  },

  {
    title: 'Category',
    type: 'category',
    placeholder: 'Select Category',
  },
  {
    title: 'Owner Name',
    type: 'text',
    name: 'ownerName',
    placeholder: 'Enter Owner Name',
  },
  {
    title: 'Manager Name',
    type: 'text',
    name: 'contactPersonName',
    placeholder: 'Enter Manager Name',
  },

  {
    title: 'Address',
    type: 'text',
    name: 'address',
    placeholder: 'Enter Address',
  },
  {
    title: 'Pincode',
    type: 'text',
    name: 'pincode',
    placeholder: 'Enter Pincode',
  },
  { title: 'City', type: 'text', name: 'city', placeholder: 'Enter City' },
  { title: 'State', type: 'text', name: 'state', placeholder: 'Enter State' },

  {
    title: 'Bank Account Number',
    type: 'number',
    name: 'bankAccountNumber',
    placeholder: 'Enter Bank Account Number',
  },
  {
    title: 'IFSC',
    type: 'text',
    name: 'ifsc',
    placeholder: 'Enter IFSC Code',
  },
  {
    title: 'Pan Number',
    type: 'text',
    name: 'pan',
    placeholder: 'Enter Pan Number',
  },
  { title: 'GSTIN', type: 'text', name: 'gst', placeholder: 'Enter GSTIN' },
];

export const registerInputData = [
  {
    title: 'Name',
    type: 'text',
    placeholder: 'Name',
    name: 'ownerName',
  },
  {
    title: 'Phone',
    type: 'number',
    name: 'mobileNumber',
    placeholder: 'Mobile Number',
  },
  { title: 'City', type: 'text', name: 'city', placeholder: 'City' },
  { title: 'Category', type: 'category', placeholder: 'Select Category' },
];
